// Склейка классов примитивов дизайн-системы матча: ложные значения пропускаются
export const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');
